import { buildLoginRedirectUrl } from "@knowfully/ui.common";
import {
  buildAuthentication,
  clearAuthentication,
} from "helpers/authenticationHelper";
import useGlobalContext from "hooks/globalData";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  ResponseCode,
  ResponseOfAuthenticationResponse,
} from "services/organizationPortalClient";

export default function LoginPage() {
  const { authenticationService, loginUrl } = useGlobalContext();
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthentication = async () => {
      const userResponseRaw: ResponseOfAuthenticationResponse = await authenticationService.getAuthenticationResponse();

      const currentPath = window.location.pathname;
      const safePath = currentPath === loginUrl() ? "/" : currentPath;

      if (
        userResponseRaw.responseCode === ResponseCode.OK &&
        userResponseRaw.data?.result
      ) {
        const userResponse = userResponseRaw.data;

        buildAuthentication(userResponse);

        navigate(safePath);
      } else {
        clearAuthentication();
        window.location.replace(buildLoginRedirectUrl(safePath));
      }
    };

    checkAuthentication();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
}
